import {
  CreditorAuthInfoEntityType,
  AddCreditorAuthorizedInformation,
} from "../Constants";

export function SaveCreditorAuthorizedInformation(
  this: any
): AddCreditorAuthorizedInformation {
  const { creditorGroupData, authorizedInformation, overrideLeval } = this;
  return {
    entityId: creditorGroupData?.id,
    entityType: CreditorAuthInfoEntityType.CREDITOR_GROUP,
    creditorAuthorizedInformation: authorizedInformation,
    overrideLevel: overrideLeval,
  };
}
